export const formatArrayToGQLString = (array) => {
  return "{" + array.join(",") + "}";
};
